import { render } from "./MonthNav.vue?vue&type=template&id=c8d71416"
import script from "./MonthNav.vue?vue&type=script&lang=js"
export * from "./MonthNav.vue?vue&type=script&lang=js"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__